import React, { useEffect, useRef } from 'react';
import { Viewer } from '@photo-sphere-viewer/core';
import '@photo-sphere-viewer/core/index.css';
import clsx from 'clsx';

const PanoramaViewer = ({ imageUrl, type = '', className = '' }) => {
  const containerRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    if (!imageUrl || !containerRef.current) return;

    viewerRef.current?.destroy();

    const viewer = new Viewer({
      container: containerRef.current,
      panorama: imageUrl,
      navbar: type == 'fullwidth' ? ['zoom', 'fullscreen'] : false,
      loadingImg: imageUrl,
    });

    viewerRef.current = viewer;

    if (type === 'fullwidth') {
      setTimeout(() => {
        try {
          viewerRef.current?.enterFullscreen?.();
        } catch (e) {
          console.error('Failed to enter fullscreen:', e);
        }
      }, 300);
    }

    return () => {
      viewerRef.current?.destroy();
    };
  }, [imageUrl, type]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: type === 'fullwidth' ? '100vh' : '500px',
        backgroundColor: '#eee',
        position: 'relative',
      }}
      className={clsx(className)}
    />
  );
};

export default PanoramaViewer;
